// MUI
import { Divider } from "@mui/material";

// Components
import StoreAndKioskConfiguration from "@/Settings/components/AdministrationTools/KeyManagementSystem/sections/StoreAndKioskConfiguration";
import AllowableTimeAwayAndChargebackAmount from "@Settings/components/AdministrationTools/KeyManagementSystem/sections/AllowableTimeAwayAndChargebackAmount";

// Types
import { TSelectValue } from "@Layouts/components/InputComponents/SmartSelector/interfaces";
import { KMSSelectedProvider } from "@Settings/types/administrationTools/utils";
import { IKmsStore } from "@/Settings/types/administrationTools/model";

type ConfigurationSetsProps = Readonly<{
	isLoading: boolean;
	selectedProvider: KMSSelectedProvider;
	isSavingStoresAndKiosks: boolean;
	// Callbacks
	handleUpdateTimeAwayAndChargebackAmount: (
		value: string | TSelectValue,
		prop: "timeAway" | "unit" | "chargebackAmount",
		providerDBProperty: string
	) => void;
	onUpdateStoreAndKioskConfiguration: (value: IKmsStore[]) => void;
}>;
export default function ConfigurationSets(props: ConfigurationSetsProps) {
	const { isLoading, selectedProvider, isSavingStoresAndKiosks, onUpdateStoreAndKioskConfiguration } = props;
	const { providerDBProperty, allowableTimeAway, chargebackAmount, kmsStores } = selectedProvider;

	switch (providerDBProperty) {
		case "oneMicro":
			return (
				<>
					<Divider sx={{ borderWidth: "1px" }} variant="fullWidth" className={"!mb-6 !mt-8 !w-[97.5%]"} />
					<StoreAndKioskConfiguration
						key={"store-and-kiosk-configuration"}
						isLoading={isLoading || isSavingStoresAndKiosks}
						kmsStores={kmsStores ?? []}
						providerDBProperty={providerDBProperty}
						// Callbacks
						onUpdateStoreAndKioskConfiguration={onUpdateStoreAndKioskConfiguration}
					/>
					<Divider sx={{ borderWidth: "1px" }} variant="fullWidth" className={"!mt-8 !mb-6 !w-[97.5%]"} />
					<AllowableTimeAwayAndChargebackAmount
						isLoading={isLoading}
						providerDBProperty={providerDBProperty}
						allowableTimeAway={allowableTimeAway}
						chargebackAmountValue={chargebackAmount}
						// Callbacks
						onActionUpdate={props.handleUpdateTimeAwayAndChargebackAmount}
					/>
				</>
			);
		case "keyTrack":
			return (
				<>
					<Divider sx={{ borderWidth: "1px" }} variant="fullWidth" className={"!mt-8 !mb-6 !w-[97.5%]"} />
					<AllowableTimeAwayAndChargebackAmount
						isLoading={isLoading}
						providerDBProperty={"keyTrack"}
						allowableTimeAway={allowableTimeAway}
						chargebackAmountValue={chargebackAmount}
						// Callbacks
						onActionUpdate={props.handleUpdateTimeAwayAndChargebackAmount}
					/>
				</>
			);
		default:
			return null;
	}
}
